// Выполненные тренировки и маршруты в «Моих тренировках»: итоги (summary), трек и телеметрия
// приходят с бэкенда (ActivityImport::TrackBuilder) уже посчитанными.

// Вид тренировки (workouts.sport): определяет бэкенд (ActivityImport::SportDetector),
// пользователь может поправить. null — не определился
export const SPORTS = ['ride', 'run', 'other'];

// Подпись на плитке: вид тренировки и формат файла
export const activityBadge = (workout, t) => [
  workout.sport && t(`workouts.activity.sports.${workout.sport}`),
  (workout.source_format || '').toUpperCase(),
].filter(Boolean).join(' · ');

// Темп бега, мин:сс на км, из скорости в км/ч
export const formatPace = (kmh) => {
  if (!kmh) return null;
  const seconds = Math.round(3600 / kmh);
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};

export const formatDistance = (meters) => {
  if (meters === null || meters === undefined) return null;
  return meters >= 10000 ? `${(meters / 1000).toFixed(1)}` : `${(meters / 1000).toFixed(2)}`;
};

export const formatDate = (iso, language) => {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString(language || undefined, { day: 'numeric', month: 'long', year: 'numeric' });
};

export const formatDateTime = (iso, language) => {
  if (!iso) return null;
  return new Date(iso).toLocaleString(language || undefined, {
    day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};
